"use strict";
exports.__esModule = true;
var CustomerPlanEnum;
(function (CustomerPlanEnum) {
    CustomerPlanEnum["SelfServe"] = "SELF_SERVE";
    CustomerPlanEnum["Platform"] = "PLATFORM";
})(CustomerPlanEnum || (CustomerPlanEnum = {}));
exports["default"] = CustomerPlanEnum;
//# sourceMappingURL=customer-plan-enum.js.map